export default __webpack_public_path__ + "static/media/carbon-accounting-1.84f683e9.png";